import createCachedOrmSelector from 'redux/utils/createCachedOrmSelector';

import getAnalysisKey from '../../getAnalysisKey';

export default createCachedOrmSelector(
  getAnalysisKey,

  (session, key) => {
    const { AnalysisVitamin } = session;

    return AnalysisVitamin
      .filter({
        ___parent: key,
      })
      .toModelArray()
      .map(item => ({
        key: item.key,
        itemKey: item.custom_витамин.key,
        label: item.custom_витамин.custom_наименование,
        value: item.custom_оценка,
      }));
  },
);
